import { render, staticRenderFns } from "./spe-bottom-navigation.vue?vue&type=template&id=04d7f409&"
import script from "./spe-bottom-navigation.component.ts?vue&type=script&lang=ts&"
export * from "./spe-bottom-navigation.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports